import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { lazy } from 'react';
import { render } from 'react-dom';
import { arqConfig } from './config';
import { i18nextInitializer } from './i18next-config/i18next-config';
import './index.css';
import CustomSpinner from './components/atoms/CustomSpinner/index';
import { ArchitectureProvider } from '@andbank-myinvestor/arq/lib/onboarding';
import { ErrorPage } from './pages/ErrorPage';

declare global {
	// eslint-disable-next-line no-unused-vars
	interface Window {
		dataLayer: any // Habilitar dataLayer para ser accedido desde TS
	}
}

const App = lazy(() => import('./App'));

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 30000,
		},
	},
});

render(
	<QueryClientProvider client={queryClient}>
		{/* devtools para react-query, solo se introducen en desarrollo process.env.NODE_ENV=development */}
		{/* las mutaciones no aparecen en la devtool https://github.com/tannerlinsley/react-query-devtools/issues/31#issuecomment-655794286 */}
		<ReactQueryDevtools initialIsOpen={false} />
		<ArchitectureProvider
			config={arqConfig}
			Idle={CustomSpinner}
			Error={ErrorPage}
			LazySuccessComponent={App}
			customInitializer={i18nextInitializer}
		></ArchitectureProvider>
	</QueryClientProvider>,
	document.getElementById('root')
);
